import React from "react";
import { PeripheralIcon } from "@aureskonnect/react-ui";

import {
    ID_PERIPHERALS,
    ID_PRINTERS,
    ID_MONETICS,
    ID_COINERS,
} from "../../../constants/menu";
import { TFn, MenuItem, ICON_SIZE } from "./types";

export function buildPeripherals(t: TFn): MenuItem {
    return {
        link: "/#",
        id: ID_PERIPHERALS,
        menuItem: t("Peripherals"),
        icon: <PeripheralIcon {...ICON_SIZE} />,
        customClassName: "sid_drp_peripheral",
        subMenu: [
            {
                id: ID_PRINTERS,
                link: "/peripherals/printers",
                menuItem: t("Printers"),
                customClassName: "sid_btn_printer",
            },
            {
                id: ID_MONETICS,
                link: "/peripherals/monetics",
                menuItem: t("Monetics"),
                customClassName: "sid_btn_monetics",
            },
            {
                id: ID_COINERS,
                link: "/peripherals/cash-management",
                menuItem: t("Coiners"),
                customClassName: "sid_btn_coinAcceptors",
            },
        ],
    };
}
